module.exports = __webpack_public_path__ + "static/media/76mm_Oto_Melara_Super_Rapid_Gun_01.c0e7af23.jpg";